import React from 'react';
import {Card} from 'primereact/card';

import './assets/anexo-visualizar.scss';
import AnexoVisualizar from './AnexoVisualizar';
import If from '../../../vendors/components/If';

interface Props {
  lista: any;
  showDownload: any;
  handleDownload: any;
  handleAllDownload?: any;
  handleTabDocumentacao?: any;
}

export default function AnexoCard({lista, handleDownload, showDownload, handleAllDownload, handleTabDocumentacao}: Props) {
  const footer = () => {
    return (
      <>
        <div className="flex justify-content-between">
          <If condition={showDownload}>
            <label
              onClick={() => handleAllDownload()}
              className="anexo-footer-label">Baixar todos</label>
          </If>
          <If condition={!showDownload}>
            <label></label>
          </If>
          <label className="anexo-footer-label">{lista.length} arquivos</label>
        </div>
      </>
    );
  }

  return (
    <>
      <Card style={{marginBottom: '0', padding: '2.6%' }} footer={footer} title="Documentação">
        <div className='flex justify-content-end'>
          <label
            onClick={() => {handleTabDocumentacao?.("documentacao")}}
            className="anexo-footer-label">Veja Mais</label>
        </div>
        <br/>
        <div className="anexo-card-wrapper">
          {lista.map((m: any, index: any) =>
            <AnexoVisualizar
              key={`visualizar-anexo-${index}`}
              showDownload={showDownload}
              handleDownload={() => handleDownload(m)}
              anexo={m}
            />
          )}
        </div>
      </Card>
    </>
  );
}
